import Image from "common/components/Image";
import horseWithLetter from "common/images/horse-with-letter.svg";
import { useSearchState } from "common/router/hooks";
import { parseNumber } from "common/utils/numbers";
import { MarketingEmailUnsubscribe } from "common/types/inbox";

import Button from "client/common/components/buttons/Button";
import { Paths, urls } from "client/routes";
import ErrorContainer from "client/common/components/errors/ErrorContainer";
import TextButton from "client/common/components/buttons/TextButton";

import { useMarketingEmailUnsubscribeCreateMutation } from "../hooks";

import styles from "../styles/UnsubscribeConfirm.module.less";

const UnsubscribeConfirm = ({
  onUnsubscribeCreate,
}: {
  onUnsubscribeCreate: (unsubscribeId: number) => void;
}) => {
  const onSuccess = (u: MarketingEmailUnsubscribe) => {
    onUnsubscribeCreate(u.id);
  };
  const {
    mutate: unsubscribe,
    isPending: isUnsubscribing,
    error,
  } = useMarketingEmailUnsubscribeCreateMutation({
    onSuccess,
  });
  const [params] = useSearchState<Paths["inbox"]["unsubscribe"]>({
    email: undefined,
    email_address_id: undefined,
    broadcast_token: undefined,
  });

  const { email, email_address_id: emailAddressId, broadcast_token: broadcastToken } = params;

  if (error || !email || !emailAddressId) {
    return <ErrorContainer />;
  }

  return (
    <div className={styles.container}>
      <Image src={horseWithLetter} alt="horse with letter" />
      <div className={styles.content}>
        <h1 className={styles.title}>Need to unsubscribe?</h1>
        {broadcastToken ? (
          <p className={styles.description}>
            We&apos;re sorry to see you go! Please note that unsubscribing will stop emails like
            this one from your veterinary clinic. You will still receive home delivery updates and
            essential communications from your veterinarian regarding your pet&apos;s health,
            upcoming appointments, or prescription information.
          </p>
        ) : (
          <p className={styles.description}>
            We&apos;re sorry to see you go! Please note that unsubscribing will remove you from our
            home delivery marketing communications list. You may still receive essential
            communications from your veterinarian regarding your pet&apos;s health, upcoming
            appointments, or prescription information, which are not affected by your subscription
            status.
          </p>
        )}
      </div>
      <div className={styles.actions}>
        <Button
          isLoading={isUnsubscribing}
          onClick={() =>
            unsubscribe({
              email,
              email_address_id: emailAddressId ? parseNumber(emailAddressId) : null,
              broadcast_token: broadcastToken,
            })
          }
        >
          Confirm
        </Button>
        <TextButton className={styles.cancel} dest={urls.home.root()}>
          Cancel
        </TextButton>
      </div>
    </div>
  );
};

export default UnsubscribeConfirm;
